import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { InputTextarea, SubmitLoaderButton } from "components/atoms";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddReportReasonAction,
  UpdateReportReasonAction,
} from "store/middlewares/dataManagement/reportReason";

function ModalEditReportReason({ row, type, filter }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    let tempObj = { ...values, type };
    if (row) {
      tempObj = { ...tempObj, id: row?.id };
      dispatch(
        UpdateReportReasonAction({
          ...tempObj,
          onSuccess: () => {
            formik.setSubmitting(false);
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    } else {
      dispatch(
        AddReportReasonAction({
          ...tempObj,
          filter,
          onSuccess: () => {
            formik.setSubmitting(false);
          },
          onError: () => {
            setFormError(true);
            formik.setSubmitting(false);
          },
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      name: row?.name ? row?.name : "",
      note: row?.note ? row?.note : "",
      arName: row?.ar_name ? row?.ar_name : "",
      arNote: row?.ar_Note ? row?.ar_Note : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      note: Yup.string().required("Reason is required"),
      arName: Yup.string().required("Name is required"),
      arNote: Yup.string().required("Reason is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Chat Report Reason</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name (English)</Label>
              <Input
                error={formik.errors.name && formik.touched.name}
                errorMsg={formik.errors.name}
                value={formik.values.name}
                type="text"
                name="name"
                isTextOnly={true}
                maxLength={50}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter name"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56">Name (Arabic)</Label>
              <Input
                error={formik.errors.arName && formik.touched.arName}
                errorMsg={formik.errors.arName}
                value={formik.values.arName}
                type="text"
                name="arName"
                isTextOnly={true}
                maxLength={50}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter name"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-start flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56 mt-4">
                Reason (English)
              </Label>
              <InputTextarea
                textareaClassName={`rounded-lg border border-solid ${
                  !formik.errors.note && `border-zinc-100`
                } w-full px-4 py-2  text-sm no-scrollbar`}
                name="note"
                maxLength={250}
                onChange={(e) => {
                  const cleaned = e.target.value.replace(/^\s+/, "");
                  formik.setFieldValue("note", cleaned);
                }}
                onBlur={formik.handleBlur}
                error={formik.errors.note && formik.touched.note}
                errorMsg={formik.errors.note}
                value={formik.values.note}
                placeholder="Enter reason"
                isRequired={false}
              />
            </div>
            <div className="flex items-start flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-56 mt-4">
                Reason (Arabic)
              </Label>
              <InputTextarea
                textareaClassName={`rounded-lg border border-solid ${
                  !formik.errors.arNote && `border-zinc-100`
                } w-full px-4 py-2 text-sm no-scrollbar`}
                name="arNote"
                maxLength={250}
                onChange={(e) => {
                  const cleaned = e.target.value.replace(/^\s+/, "");
                  formik.setFieldValue("arNote", cleaned);
                }}
                onBlur={formik.handleBlur}
                error={formik.errors.arNote && formik.touched.arNote}
                errorMsg={formik.errors.arNote}
                value={formik.values.arNote}
                placeholder="Enter reason"
                isRequired={false}
              />
            </div>
            <div className="flex justify-end">
              <SubmitLoaderButton
                type="submit"
                btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditReportReason;
